import React from 'react';
import './FAQ.css';
import { SiWhatsapp, SiGmail } from "react-icons/si";

function ContactUs() {

  return (
    <div>
      <h1>Frequently Asked Questions (FAQs)</h1>
      <h2>
        <p>Q: How does Orderlords work? A: Orderlords is an online food delivery service.
           Simply select the restaurant you want to order from, choose your meals, and proceed
           to checkout. Your order will be prepared by the restaurant and delivered straight to
           your door by our team.<br></br></p>
        <p>Q: How can I place an order? A: You can place an order through our app. After
           creating an account, choose a restaurant, select your meals, and proceed to
           checkout.<br></br></p>
        <p>Q: What areas do you deliver to? A: Currently, we deliver to areas within Cape Town CBD, Milnerton and Constantia areas.
           Please enter your address in our app or website to see if we serve your area.<br></br></p>
        <p>Q: How long does delivery take? A: Delivery times can vary depending on the
           restaurant and your location.<br></br></p>
        <p>Q: How can I pay for my order? A: We accept all major credit and debit cards. You
           can also pay using various mobile payment platforms.<br></br></p>
        <p>Q: Can I schedule an order for later? A: Yes, you can schedule orders up to one
           week in advance. Simply choose the "Schedule" option when placing your order and
           select the date and time you want your food to be delivered.<br></br></p>
        <p>Q: Can I modify or cancel my order after placing it? A: We begin processing your
           order as soon as you place it, which means modifications or cancellations can't
           always be accommodated. If you need to change or cancel your order, please contact
           our customer service immediately.<br></br></p>
        <p>Q: What if there was an issue with my order? A: If you experience any issues with
           your order, such as missing or incorrect items, please contact our customer service.
           We'll work with you to resolve the issue as quickly as possible.<br></br></p>
        <p>Q: How do I contact customer service? A: You can reach our customer service team
           by email at support@orderlords.com or by calling +27673101827<br></br></p>
        <p>Q: How do you ensure food safety during delivery? A: Our delivery team follows
           strict hygiene and handling standards to ensure your food is safe and arrives in the
           best condition.<br></br></p>
        <p>Q: How do you protect my privacy and data? A: At Orderlords, we take your
           privacy seriously. We use secure servers and data encryption, and we comply with all
           relevant data protection laws. <br></br>You can learn more by reading our Privacy Policy.</p>
        
      </h2>
      <div>
        <a href="mailto:hello@burgerboss.co.za" className="contact-option">
          <SiGmail size="1.5em"/><span>Send us an Email</span>
        </a>
        <a href="https://wa.link/31y19l" className="contact-option">
          <SiWhatsapp size="1.5em"/><span>Chat on Whatsapp</span>
        </a>
      </div>
    </div>
  );
}

export default ContactUs;
